<div class="title">{{ "measurement.tools" | translate}}</div>

<div class="tiles">
  @for (measurementType of measurementTypes; track $index) {
     <div class="tile" role="button" (click)="onMeasurementTypeChange(measurementType)" [class.active]="selectedMeasurement() === measurementType" [class.disabled]="disabled()">
      {{  "measurement." + measurementType | translate}}
    </div>
  }
</div>
